import { rest } from 'msw'

export const testEnvHostname = 'http://localhost'

export const handlers = [
  rest.get(`${testEnvHostname}/api/v2/early/utl`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        games: [
          {
            autoPlay: false,
            avatarUrl: '@h2/tests/svgMock.svg',
            badges: [
              {
                badgeId: 'assessment',
                badgeName: 'Assessment Badge',
                level: 3,
                levelName: 'Gold'
              }
            ],
            currentLevel: 1,
            face: 12,
            hair: '#000000',
            id: 884,
            lastAccessed: '2023-08-23T00:53:51.824999Z',
            level1CompletionDate: null,
            level1CompletionNotes: null,
            level2CompletionDate: null,
            level2CompletionNotes: null,
            level3CompletionDate: null,
            level3CompletionNotes: null,
            level4CompletionDate: null,
            level4CompletionNotes: null,
            level5CompletionDate: null,
            level5CompletionNotes: null,
            name: 'Jacob',
            notes: [],
            setup: true,
            skin: '#fbcc9b',
            started: '2023-08-23T00:52:56.436431Z',
            userId: 95388
          }
        ]
      })
    )
  })
]
